// /live (lobby with rooms by instrument), /live/[symbol] + ChatRoomView.
export const live: Record<string, string> = {
  'Live Trading Chat': 'Trejding ćaskanje uživo',
  'online': 'onlajn',
  'Unread messages': 'Nepročitane poruke',
  'Members': 'Članovi',
  'Mention in chat': 'Označi u chatu',
  'All members': 'Svi članovi',
  'Everyone in the FX Doctor community.': 'Svi u FX Doctor zajednici.',
  'Search members…': 'Pretraži članove…',
  'No members found.': 'Nema pronađenih članova.',
  'Global chat': 'Globalno ćaskanje',
  // Lobby
  'Rooms': 'Sobe',
  'Rooms by instrument — chat while you trade.': 'Sobe po instrumentima — ćaskaj dok trguješ.',
  'General': 'Opšte',
  'General chat': 'Opšte ćaskanje',
  'Everything that is not one instrument.': 'Sve što nije jedan instrument.',
  'Open a room': 'Otvori sobu',
  'Instrument, e.g. XAUUSD': 'Instrument, npr. XAUUSD',
  'Open': 'Otvori',
  'Enter an instrument like XAUUSD, EURUSD or BTCUSD.': 'Unesi instrument kao XAUUSD, EURUSD ili BTCUSD.',
  'Too many rooms opened — try again in a bit.': 'Previše otvorenih soba — probaj malo kasnije.',
  'Verified traders': 'Verifikovani trejderi',
  'Verified trader room': 'Soba verifikovanog trejdera',
  'Open your own live room': 'Otvori svoju live sobu',
  'Metals & commodities': 'Metali i roba',
  'Indices': 'Indeksi',
  'Crypto': 'Kripto',
  'Stocks': 'Akcije',
  'Gold': 'Zlato',
  'Silver': 'Srebro',
  'Oil (WTI)': 'Nafta (WTI)',
  'Live trading': 'Trgovanje uživo',
  'No recent messages': 'Nema skorašnjih poruka',
  'chart': 'grafikon',
  'Back to rooms': 'Nazad na sobe',
  'Pick a room': 'Izaberi sobu',
  'Active now': 'Aktivno sada',
  'in the last 24h': 'u poslednja 24h',
  'messages': 'poruka',
  'No chat yet for': 'Još nema ćaskanja za',
  'Share a setup or a chart — the session starts here.': 'Podeli setap ili grafikon — sesija počinje ovde.',

  // ChatRoomView
  'No messages yet': 'Još nema poruka',
  'Say something — the session starts here.': 'Reci nešto — sesija počinje ovde.',
  'Could not send the message.': 'Nije moguće poslati poruku.',
  'Report message by': 'Prijavi poruku od',
  'why? (Spam / Abusive / Other)': 'zašto? (Spam / Uvredljivo / Drugo)',
  'Reported. Our team will review this message.': 'Prijavljeno. Naš tim će pregledati ovu poruku.',
  'Could not send the report.': 'Nije moguće poslati prijavu.',
  'Block': 'Blokiraj',
  'You will no longer see their content, and they cannot DM you.': 'Više nećeš videti njegov sadržaj, a on ne može da ti šalje poruke.',
  'Could not block this user.': 'Nije moguće blokirati ovog korisnika.',
  'trader': 'trejder',
  'Report': 'Prijavi',
  'View full size': 'Prikaži u punoj veličini',
  'Attach chart image': 'Priloži sliku grafikona',
  'Message…': 'Poruka…',
  'Sign in to chat': 'Prijavi se za ćaskanje',
  'Paste a screenshot (Ctrl+V) or drop an image to comment on a chart.': 'Nalepi screenshot (Ctrl+V) ili prevuci sliku da prokomentarišeš grafikon.',
  'Drop the image to attach it': 'Pusti sliku da je priložiš',
  'Remove image': 'Ukloni sliku',
  'Reply': 'Odgovori',
  'Only images can be pasted here.': 'Ovde se mogu nalepiti samo slike.',

  // Reactions, reply quote, pin (2026-10-01)
  'Like': 'Sviđa mi se',
  'Dislike': 'Ne sviđa mi se',
  'Fire': 'Vatra',
  'Spot on': 'U sridu',
  'Haha': 'Haha',
  'Replying to a message': 'Odgovor na poruku',
  'Replying to': 'Odgovaraš na',
  'Cancel reply': 'Otkaži odgovor',
  'Pin': 'Zakači',
  'Unpin': 'Otkači',
  'Pinned': 'Zakačeno',
  'Could not update the pin.': 'Nije moguće izmeniti zakačenu poruku.',

  // InviteButton (/live, /live/[symbol], group header)
  'Invite': 'Pozovi',
  'Invite to chat': 'Pozovi u ćaskanje',
  'Send the link — whoever opens it joins the chat.': 'Pošalji link — ko ga otvori, ulazi u ćaskanje.',
  'More…': 'Više…',
  'Could not create the invite link.': 'Nije moguće napraviti link za pozivnicu.',
  'Join me in the live trading chat on ShowMeTrade': 'Pridruži mi se u trejding ćaskanju uživo na ShowMeTrade',
  'Join the live chat for': 'Pridruži se ćaskanju uživo za',
  'on ShowMeTrade': 'na ShowMeTrade',
  'Only works for people already approved as Zajednica members — anyone else will see the request-access page instead.': 'Radi samo za već odobrene članove Zajednice — svi ostali će umesto ćaskanja videti stranicu za zahtev pristupa.',
  'Join our group': 'Pridruži se našoj grupi',
  'You are now in the live chat!': 'Sada si u ćaskanju uživo!',
  'You joined the group!': 'U grupi si!',

  // /chat/join/[token]
  'Invite link': 'Link za pozivnicu',
  'This invite link is invalid or has expired.': 'Ovaj link za pozivnicu nije važeći ili je istekao.',
  'This group is full.': 'Ova grupa je puna.',
  'Go to messages': 'Idi na poruke',
  'You have an invite to the group': 'Imaš pozivnicu za grupu',
  'invited by': 'poziva',
  'Joining the chat…': 'Uključujem te u ćaskanje…',
  'Sign in to join': 'Prijavi se da se pridružiš',
  // scheduled sessions (LiveEvent, 2026-09-06)
  'Live now': 'Uživo sada',
  'Live session': 'Sesija uživo',
  'Join now': 'Uđi odmah',
  'Open the room': 'Otvori sobu',
  'Free · sign in to write, anyone can read': 'Besplatno · prijavi se da pišeš, čitati može svako',
  // community gate — rewritten 2026-09-07: this page IS the Zajednica login, so it explains
  // and advertises Zajednica itself rather than listing unrelated products.
  'Members only': 'Samo za članove',
  'FX Doctor Zajednica': 'FX Doctor Zajednica',
  'A peek inside': 'Pogled iznutra',
  'The paid coaching community behind fxdoctor.pro — this page is its members-only room. Twice-monthly live setup reviews, a weekly analysis video, a fixed Thursday Q&A window and a full archive of every session. Not signals — you learn to decide, then trade your own idea.': 'Plaćena edukativna zajednica iza fxdoctor.pro — ova strana je njena soba samo za članove. Provera setapa uživo dva puta mesečno, nedeljni video analiza, fiksan termin za pitanja četvrtkom i puna arhiva svake sesije. Bez signala — učiš da odlučuješ, pa trguješ sopstvenom idejom.',
  '100 €/month, or 1 000 €/year': '100 €/mesečno, ili 1.000 €/godišnje',
  'A PU Prime account balance under the FX Doctor link lowers it — 75 € at 500 €+, 50 € at 1 000 €+, free at 2 500 €+.': 'Stanje na PU Prime nalogu preko FX Doctor linka je snižava — 75 € na 500 €+, 50 € na 1.000 €+, besplatno na 2.500 €+.',
  'Join on fxdoctor.pro →': 'Učlani se na fxdoctor.pro →',
  'Already have it, another way?': 'Već je imaš, na drugi način?',
  'Mentorski kurs': 'Mentorski kurs',
  'Master 1-na-1': 'Master 1-na-1',
  'graduates': 'polaznici',
  ' — both include everything Zajednica has.': ' — oba uključuju sve što ima Zajednica.',
  "Looking for signals, not coaching? FX Doctor's Gold": "Tražiš signale, ne edukaciju? FX Doctor's Gold",
  '(XAUUSD, $100/month) →': '(XAUUSD, 100 $/mesečno) →',
  'is a separate ShowMeTrade channel — subscribers get this page automatically, no request needed.': 'je poseban kanal na ShowMeTrade — pretplatnici automatski dobijaju ovu stranu, bez zahteva.',
  'Prefer to pay Gold by direct link?': 'Više voliš da platiš Gold direktnim linkom?',
  'Pay on Stripe →': 'Plati preko Stripe-a →',
  "Sign in here and request access below afterwards (it isn't automatic for this link).": 'Prijavi se ovde i posle zatraži pristup ispod (za ovaj link nije automatski).',
  "Paid FX Doctor's Gold via the Stripe link": "Platio/la FX Doctor's Gold preko Stripe linka",
  'Email you used at Stripe checkout': 'Email koji si koristio/la pri plaćanju na Stripe-u',
  'Already part of the community?': 'Već si deo zajednice?',
  'Sign in (free, 30 seconds) and request access.': 'Prijavi se (besplatno, 30 sekundi) i zatraži pristup.',
  'Sign in and request access': 'Prijavi se i zatraži pristup',
  'Request sent — waiting for approval.': 'Zahtev poslat — čeka odobrenje.',
  'You will see the rooms here as soon as @fxdoctor confirms. Usually within a few hours.': 'Sobe ćeš videti ovde čim @fxdoctor potvrdi. Obično u roku od par sati.',
  'Your previous request was not approved.': 'Prethodni zahtev nije odobren.',
  'You can send a new one with more details.': 'Možeš poslati novi sa više detalja.',
  'Request access': 'Zatraži pristup',
  'How are you part of the community?': 'Kako si deo zajednice?',
  'Zajednica member (paid on fxdoctor.pro)': 'Član Zajednice (plaćeno na fxdoctor.pro)',
  'Completed the Mentorski kurs': 'Završen Mentorski kurs',
  'Completed Master 1-na-1': 'Završen Master 1-na-1',
  'Something else': 'Nešto drugo',
  'Email or name you registered with on fxdoctor.pro': 'Email ili ime kojim si se prijavio/la na fxdoctor.pro',
  'Account number and balance (2 500 €+ = free Zajednica)': 'Broj naloga i stanje (2.500 €+ = besplatna Zajednica)',
  'Year / month, or your name as registered': 'Godina / mesec, ili ime pod kojim si prijavljen',
  'Tell us how you are part of the community': 'Napiši kako si deo zajednice',
  'Enter the email or name you registered with on fxdoctor.pro.': 'Upiši email ili ime kojim si se prijavio/la na fxdoctor.pro.',
  'Note (optional)': 'Napomena (opciono)',
  'Sending…': 'Šaljem…',
  'Send request': 'Pošalji zahtev',
  'No account yet? A': 'Nemaš još nalog? Da',
  'PU Prime account under the FX Doctor link': 'PU Prime nalog preko FX Doctor linka',
  'PU Prime account': 'PU Prime nalog',
  'under the FX Doctor link with 2 500 €+ on balance makes Zajednica free — below that, membership is still 100 €/month (75 €/50 € on smaller balances).': 'preko FX Doctor linka sa 2.500 €+ na stanju čini Zajednicu besplatnom — ispod toga, članarina je i dalje 100 €/mesečno (75 €/50 € na manjem stanju).',
  'Pick how you are part of the community.': 'Izaberi kako si deo zajednice.',
  'Enter your PU Prime account number.': 'Upiši broj PU Prime naloga.',
  'Welcome to the community 🎉': 'Dobrodošao u zajednicu 🎉',
  'Your live chat access is approved — rooms by instrument and live sessions are open for you.': 'Tvoj pristup live chatu je odobren — sobe po instrumentima i sesije uživo su otvorene za tebe.',
  'Open the live chat →': 'Otvori live chat →',
  'Sign up free': 'Registruj se besplatno',
  'Join the lecture': 'Uđi na predavanje',
  'Sign up free for the lecture link': 'Registruj se besplatno za link predavanja',
  'Chat room': 'Chat soba',
  'Watch the lecture': 'Gledaj predavanje',
  'Sign up free to watch the lecture': 'Registruj se besplatno i gledaj predavanje',
  'Hide video': 'Sakrij video',
  'Show video': 'Prikaži video',
  'Free with a ShowMeTrade account': 'Besplatno uz ShowMeTrade nalog',
  'Live chat is open to everyone': 'Live chat je otvoren za sve',
  'Create a free ShowMeTrade account to join the rooms, chat with traders and comment in real time.': 'Napravi besplatan ShowMeTrade nalog i uđi u sobe, dopisuj se sa trejderima i komentariši uživo.',
};
